// import React, { useState, useEffect } from "react";
// import { useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";
// import { Calendar, Plus, List, Loader, Clock, MapPin, ChevronRight, X } from "lucide-react";
// import BookingScheduler from "../components/BookingSchedulerNew";
// import ScheduledBookingList from "../components/ScheduledBookingList";
// import BookingGraph from "../components/BookingGraph";
// import { useVehicles } from "../hooks/useVehicles";
// import { useScheduledBookings } from "../hooks/useScheduledBookings";
// import EmployeeLayout from "../components/EmployeeLayout";
// import {
//   getForkBookingDetailsAll,
//   getFBookingDetails,
//   getForkBookingDetailsByDate,
// } from "../services/bookingService";

// // Tab Button Component
// function TabButton({ active, onClick, children, icon: Icon }) {
//   return (
//     <button
//       onClick={onClick}
//       className={`inline-flex items-center gap-1.5 px-3 py-2 text-sm font-medium transition-all border-b-2 ${
//         active
//           ? "text-gray-900 border-gray-900"
//           : "text-gray-500 border-transparent hover:text-gray-700 hover:border-gray-300"
//       }`}
//     >
//       {Icon && <Icon size={14} />}
//       {children}
//     </button>
//   );
// }

// // Stat Card Component
// function StatCard({ title, value, icon: Icon, color, onClick }) {
//   const colorClasses = {
//     blue: "bg-blue-50 border-blue-200 text-blue-600",
//     green: "bg-emerald-50 border-emerald-200 text-emerald-600",
//     purple: "bg-purple-50 border-purple-200 text-purple-600",
//   };
  
//   const bgColor = colorClasses[color] || colorClasses.blue;
  
//   return (
//     <div
//       onClick={onClick}
//       className={`${bgColor} border rounded-lg p-3 cursor-pointer transition-all hover:shadow-md`}
//     >
//       <div className="flex items-center justify-between mb-1">
//         <Icon size={14} className={bgColor.split(' ')[2]} />
//         <span className="text-lg font-bold">{value}</span>
//       </div>
//       <p className="text-xs font-medium">{title}</p>
//     </div>
//   );
// }

// export default function ScheduleBooking() {
//   const navigate = useNavigate();
//   const { authKey, userDetails } = useSelector((state) => state.auth);
//   const {
//     vehicles,
//     loading: vehiclesLoading,
//     error: vehiclesError,
//     loadVehicles,
//   } = useVehicles();
//   const {
//     bookings,
//     loading: bookingsLoading,
//     loadBookings,
//   } = useScheduledBookings();
//   const [showScheduler, setShowScheduler] = useState(false);
//   const [activeTab, setActiveTab] = useState("bookings");
//   const [showAvailability, setShowAvailability] = useState(false);
//   const [availabilityBookings, setAvailabilityBookings] = useState([]);
//   const [availabilityLoading, setAvailabilityLoading] = useState(false);

//   useEffect(() => {
//     if (!authKey) {
//       navigate("/login");
//     }
//   }, [authKey, navigate]);

//   const fetchInitialBookingDetails = async () => {
//     console.log("[ScheduleBooking] Fetching initial booking details...");
//     try {
//       await Promise.all([
//         getForkBookingDetailsAll(),
//         getFBookingDetails(),
//       ]);
//     } catch (error) {
//       console.error("[ScheduleBooking] Error fetching initial booking details:", error);
//     }
//   };

//   useEffect(() => {
//     if (authKey) {
//       loadVehicles();
//       loadBookings();
//       fetchInitialBookingDetails();
//     }
//   }, [authKey, loadVehicles, loadBookings]);

//   if (!userDetails) {
//     return (
//       <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
//         <div className="bg-white border border-gray-100 rounded-xl shadow-sm p-8 text-center max-w-md">
//           <Loader className="mx-auto mb-4 text-gray-400 animate-spin" size={32} />
//           <h2 className="text-lg font-semibold text-gray-900 mb-1">Loading Your Session</h2>
//           <p className="text-xs text-gray-500">Please wait...</p>
//         </div>
//       </div>
//     );
//   }

//   // Calculate booking stats
//   const bookingStats = {
//     total: bookings?.length || 0,
//     pending: bookings?.filter(b => b.status === "Pending" || b.status === "P").length || 0,
//     active: bookings?.filter(b => b.status === "Active" || b.status === "A").length || 0,
//   };

//   return (
//     <EmployeeLayout>
//       {/* Header Section */}
//       <div className="mb-4">
//         <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3">
//           <div>
//             <h1 className="text-lg sm:text-xl font-semibold text-gray-900 flex items-center gap-2">
//               <Calendar size={20} />
//               Schedule Booking
//             </h1>
//             <p className="text-xs text-gray-500 mt-0.5">
//               Book vehicles with precision timing
//             </p>
//           </div>
//           <div className="flex gap-2 w-full sm:w-auto">
//             {!showScheduler && (
//               <button
//                 onClick={async () => {
//                   const isOpening = !showAvailability;
//                   if (isOpening) {
//                     setAvailabilityLoading(true);
//                     try {
//                       const today = new Date();
//                       const startOfWeek = new Date(today);
//                       startOfWeek.setDate(today.getDate() - today.getDay() + 1);
//                       const weekDates = [];
//                       for (let i = 0; i < 7; i++) {
//                         const date = new Date(startOfWeek);
//                         date.setDate(startOfWeek.getDate() + i);
//                         weekDates.push(date.toISOString().split("T")[0]);
//                       }
//                       const bookingsArrays = await Promise.all(
//                         weekDates.map((date) => getForkBookingDetailsByDate(date))
//                       );
//                       const allBookings = bookingsArrays.flat();
//                       setAvailabilityBookings(Array.isArray(allBookings) ? allBookings : []);
//                     } catch (error) {
//                       console.error("Error fetching fork bookings:", error);
//                       setAvailabilityBookings([]);
//                     } finally {
//                       setAvailabilityLoading(false);
//                     }
//                   }
//                   setShowAvailability(isOpening);
//                   if (isOpening) setShowScheduler(false);
//                 }}
//                 disabled={availabilityLoading}
//                 className={`inline-flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium rounded-lg transition ${
//                   showAvailability
//                     ? "bg-gray-100 text-gray-700 hover:bg-gray-200"
//                     : "bg-gray-900 text-white hover:bg-gray-800"
//                 } disabled:opacity-50`}
//               >
//                 <Clock size={14} />
//                 {availabilityLoading ? "Loading..." : showAvailability ? "Hide Availability" : "Check Availability"}
//               </button>
//             )}
//             {(!showScheduler || activeTab === "bookings") && (
//               <button
//                 onClick={() => {
//                   setShowScheduler(true);
//                   setActiveTab("create");
//                   setShowAvailability(false);
//                 }}
//                 className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-emerald-600 text-white text-sm font-medium rounded-lg hover:bg-emerald-700 transition"
//               >
//                 <Plus size={14} />
//                 New Booking
//               </button>
//             )}
//           </div>
//         </div>
//       </div>

//       {/* Stats Cards */}
//       <div className="grid grid-cols-3 gap-2 mb-4">
//         <StatCard title="Total Bookings" value={bookingStats.total} icon={Calendar} color="blue" />
//         <StatCard title="Active" value={bookingStats.active} icon={Clock} color="green" />
//         <StatCard title="Pending" value={bookingStats.pending} icon={Loader} color="purple" />
//       </div>

//       {/* Tab Navigation */}
//       {showScheduler && (
//         <div className="border-b border-gray-100 mb-4">
//           <div className="flex gap-1">
//             <TabButton
//               active={activeTab === "create"}
//               onClick={() => setActiveTab("create")}
//               icon={Plus}
//             >
//               Create Booking
//             </TabButton>
//             <TabButton
//               active={activeTab === "bookings"}
//               onClick={() => setActiveTab("bookings")}
//               icon={List}
//             >
//               My Bookings
//             </TabButton>
//           </div>
//         </div>
//       )}

//       {/* Availability Graph */}
//       {showAvailability && (
//         <div className="mb-4">
//           {availabilityLoading ? (
//             <div className="bg-white border border-gray-100 rounded-lg shadow-sm p-8 text-center">
//               <Loader className="mx-auto mb-3 text-gray-400 animate-spin" size={24} />
//               <p className="text-xs text-gray-500">Loading availability...</p>
//             </div>
//           ) : (
//             <BookingGraph
//               bookings={availabilityBookings}
//               vehicles={Array.isArray(vehicles) ? vehicles : []}
//               initialDate={new Date().toISOString().split("T")[0]}
//               onCreateBooking={(bookingData) => {
//                 setShowScheduler(true);
//                 setActiveTab("create");
//                 setShowAvailability(false);
//                 console.log("Create booking with data:", bookingData);
//               }}
//               onEditBooking={(booking) => {
//                 console.log("Edit booking:", booking);
//               }}
//             />
//           )}
//         </div>
//       )}

//       {/* Main Content */}
//       {!showAvailability && (
//         <>
//           {/* Create Booking Tab */}
//           {showScheduler && activeTab === "create" && (
//             <div className="bg-white border border-gray-100 rounded-lg shadow-sm overflow-hidden">
//               {vehiclesLoading ? (
//                 <div className="p-8 text-center">
//                   <Loader className="mx-auto mb-3 text-gray-400 animate-spin" size={24} />
//                   <p className="text-xs text-gray-500">Loading vehicles...</p>
//                 </div>
//               ) : vehiclesError ? (
//                 <div className="p-6 text-center">
//                   <div className="bg-red-50 border border-red-100 rounded-lg p-4">
//                     <h3 className="text-sm font-semibold text-red-900 mb-1">Unable to Load Vehicles</h3>
//                     <p className="text-xs text-red-700 mb-3">{vehiclesError}</p>
//                     <button
//                       onClick={() => window.location.reload()}
//                       className="px-3 py-1.5 bg-red-600 text-white text-xs rounded-lg hover:bg-red-700 transition"
//                     >
//                       Try Again
//                     </button>
//                   </div>
//                 </div>
//               ) : (
//                 <BookingScheduler
//                   vehicles={Array.isArray(vehicles) ? vehicles : []}
//                   onBookingCreated={async () => {
//                     setShowScheduler(false);
//                     setActiveTab("bookings");
//                     await fetchInitialBookingDetails();
//                     await loadBookings();
//                   }}
//                 />
//               )}
//             </div>
//           )}

//           {/* My Bookings Tab */}
//           {(!showScheduler || activeTab === "bookings") && (
//             <div className="bg-white border border-gray-100 rounded-lg shadow-sm overflow-hidden">
//               {bookingsLoading ? (
//                 <div className="p-8 text-center">
//                   <Loader className="mx-auto mb-3 text-gray-400 animate-spin" size={24} />
//                   <p className="text-xs text-gray-500">Loading your bookings...</p>
//                 </div>
//               ) : bookings && bookings.length > 0 ? (
//                 <ScheduledBookingList />
//               ) : (
//                 <div className="p-12 text-center">
//                   <div className="flex flex-col items-center gap-3">
//                     <div className="p-3 bg-gray-50 rounded-full">
//                       <Calendar size={32} className="text-gray-400" />
//                     </div>
//                     <div>
//                       <h3 className="text-sm font-semibold text-gray-900 mb-1">No Bookings Yet</h3>
//                       <p className="text-xs text-gray-500 mb-4">Start by creating your first scheduled vehicle booking</p>
//                       <button
//                         onClick={() => {
//                           setShowScheduler(true);
//                           setActiveTab("create");
//                         }}
//                         className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-gray-900 text-white text-sm font-medium rounded-lg hover:bg-gray-800 transition"
//                       >
//                         <Plus size={14} />
//                         Create Your First Booking
//                       </button>
//                     </div>
//                   </div>
//                 </div>
//               )}
//             </div>
//           )}
//         </>
//       )}
//     </EmployeeLayout>
//   );
// }


import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Calendar, Plus, List, Loader, ChevronRight, Clock, MapPin, Truck } from "lucide-react";
import BookingScheduler from "../components/BookingSchedulerNew";
import ScheduledBookingList from "../components/ScheduledBookingList";
import BookingGraph from "../components/BookingGraph";
import { useVehicles } from "../hooks/useVehicles";
import { useScheduledBookings } from "../hooks/useScheduledBookings";
import EmployeeLayout from "../components/EmployeeLayout";
import AdvancedBookingForm from "../pages/Advancedbookingform";
import {
  getForkBookingDetailsAll,
  getFBookingDetails,
  getForkBookingDetailsByDate,
} from "../services/bookingService";

// Tab Button Component
function TabButton({ active, onClick, children, icon: Icon }) {
  return (
    <button
      onClick={onClick}
      className={`inline-flex items-center gap-1.5 px-3 py-2 text-sm font-medium transition-all border-b-2 ${
        active
          ? "text-gray-900 border-gray-900"
          : "text-gray-500 border-transparent hover:text-gray-700 hover:border-gray-300"
      }`}
    >
      {Icon && <Icon size={14} />}
      {children}
    </button>
  );
}

// Stat Card Component
function StatCard({ title, value, icon: Icon, color, onClick }) {
  const colorClasses = {
    blue: "bg-blue-50 border-blue-200 text-blue-600",
    green: "bg-emerald-50 border-emerald-200 text-emerald-600",
    purple: "bg-purple-50 border-purple-200 text-purple-600",
    yellow: "bg-yellow-50 border-yellow-200 text-yellow-600",
  };
  
  const bgColor = colorClasses[color] || colorClasses.blue;
  
  return (
    <div
      onClick={onClick}
      className={`${bgColor} border rounded-lg p-3 cursor-pointer transition-all hover:shadow-md`}
    >
      <div className="flex items-center justify-between mb-1">
        <Icon size={14} className={bgColor.split(' ')[2]} />
        <span className="text-lg font-bold">{value}</span>
      </div>
      <p className="text-xs font-medium">{title}</p>
    </div>
  );
}

export default function ScheduleBooking() {
  const navigate = useNavigate();
  const { authKey, userDetails } = useSelector((state) => state.auth);
  const {
    vehicles,
    loading: vehiclesLoading,
    error: vehiclesError,
    loadVehicles,
  } = useVehicles();
  const {
    bookings,
    loading: bookingsLoading,
    loadBookings,
  } = useScheduledBookings();
  const [showScheduler, setShowScheduler] = useState(false);
  const [activeTab, setActiveTab] = useState("bookings");
  const [showAvailability, setShowAvailability] = useState(false);
  const [availabilityBookings, setAvailabilityBookings] = useState([]);
  const [availabilityLoading, setAvailabilityLoading] = useState(false);
  const [showAdvancedForm, setShowAdvancedForm] = useState(false);

  useEffect(() => {
    if (!authKey) {
      navigate("/login");
    }
  }, [authKey, navigate]);

  const fetchInitialBookingDetails = async () => {
    console.log("[ScheduleBooking] Fetching initial booking details...");
    try {
      const [forkDetails, bookingDetails] = await Promise.all([
        getForkBookingDetailsAll(),
        getFBookingDetails(),
      ]);
      console.log("[ScheduleBooking] Fork booking details fetched:", forkDetails);
      console.log("[ScheduleBooking] Booking details fetched:", bookingDetails);
    } catch (error) {
      console.error("[ScheduleBooking] Error fetching initial booking details:", error);
    }
  };

  useEffect(() => {
    if (authKey) {
      loadVehicles();
      loadBookings();
      fetchInitialBookingDetails();
    }
  }, [authKey, loadVehicles, loadBookings]);

  // Calculate booking stats
  const bookingStats = {
    total: bookings?.length || 0,
    pending: bookings?.filter(b => b.status === "Pending" || b.status === "P").length || 0,
    active: bookings?.filter(b => b.status === "Active" || b.status === "A").length || 0,
    completed: bookings?.filter(b => b.status === "Completed" || b.status === "CO").length || 0,
  };

  if (!userDetails) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
        <div className="bg-white border border-gray-100 rounded-xl shadow-sm p-8 text-center max-w-md">
          <Loader className="mx-auto mb-4 text-gray-400 animate-spin" size={32} />
          <h2 className="text-lg font-semibold text-gray-900 mb-1">Loading Your Session</h2>
          <p className="text-xs text-gray-500">Please wait...</p>
        </div>
      </div>
    );
  }

  return (
    <EmployeeLayout>
      {/* Header Section */}
      <div className="mb-4">
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3">
          <div>
            <h1 className="text-lg sm:text-xl font-semibold text-gray-900 flex items-center gap-2">
              <Calendar size={20} />
              Schedule Booking
            </h1>
            <p className="text-xs text-gray-500 mt-0.5">
              Book vehicles with precision timing
            </p>
          </div>
          <div className="flex flex-wrap gap-2">
            {!showScheduler && !showAdvancedForm && (
              <button
                onClick={async () => {
                  const isOpening = !showAvailability;
                  if (isOpening) {
                    setAvailabilityLoading(true);
                    try {
                      const today = new Date();
                      const startOfWeek = new Date(today);
                      startOfWeek.setDate(today.getDate() - today.getDay() + 1);
                      const weekDates = [];
                      for (let i = 0; i < 7; i++) {
                        const date = new Date(startOfWeek);
                        date.setDate(startOfWeek.getDate() + i);
                        weekDates.push(date.toISOString().split("T")[0]);
                      }
                      const bookingsArrays = await Promise.all(
                        weekDates.map((date) => getForkBookingDetailsByDate(date))
                      );
                      const allBookings = bookingsArrays.flat();
                      setAvailabilityBookings(Array.isArray(allBookings) ? allBookings : []);
                    } catch (error) {
                      console.error("Error fetching fork bookings:", error);
                      setAvailabilityBookings([]);
                    } finally {
                      setAvailabilityLoading(false);
                    }
                  }
                  setShowAvailability(isOpening);
                  if (isOpening) setShowScheduler(false);
                }}
                disabled={availabilityLoading}
                className={`inline-flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium rounded-lg transition ${
                  showAvailability
                    ? "bg-gray-100 text-gray-700 hover:bg-gray-200"
                    : "bg-gray-900 text-white hover:bg-gray-800"
                } disabled:opacity-50`}
              >
                <Calendar size={14} />
                {availabilityLoading ? "Loading..." : showAvailability ? "Hide Availability" : "Check Availability"}
              </button>
            )}
            
            {!showScheduler && !showAdvancedForm && (
              <button
                onClick={() => {
                  setShowAdvancedForm(true);
                  setShowAvailability(false);
                }}
                className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-emerald-600 text-white text-sm font-medium rounded-lg hover:bg-emerald-700 transition"
              >
                <Plus size={14} />
                Unplanned Booking
              </button>
            )}

            {(!showScheduler || activeTab === "bookings") && !showAdvancedForm && (
              <button
                onClick={() => {
                  setShowScheduler(true);
                  setActiveTab("create");
                  setShowAvailability(false);
                }}
                className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-purple-600 text-white text-sm font-medium rounded-lg hover:bg-purple-700 transition"
              >
                <Plus size={14} />
                New Booking
              </button>
            )}
          </div>
        </div>
      </div>

      {/* Stats Cards */}
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 mb-4">
        <StatCard title="Total Bookings" value={bookingStats.total} icon={Calendar} color="blue" />
        <StatCard title="Active" value={bookingStats.active} icon={Clock} color="green" />
        <StatCard title="Pending" value={bookingStats.pending} icon={Loader} color="yellow" />
        <StatCard title="Completed" value={bookingStats.completed} icon={Truck} color="purple" />
      </div>

      {/* Tab Navigation */}
      {showScheduler && (
        <div className="border-b border-gray-100 mb-4">
          <div className="flex gap-1">
            <TabButton
              active={activeTab === "create"}
              onClick={() => setActiveTab("create")}
              icon={Plus}
            >
              Create Booking
            </TabButton>
            <TabButton
              active={activeTab === "bookings"}
              onClick={() => setActiveTab("bookings")}
              icon={List}
            >
              My Bookings
            </TabButton>
          </div>
        </div>
      )}

      {/* Availability Graph */}
      {showAvailability && (
        <div className="mb-4">
          {availabilityLoading ? (
            <div className="bg-white border border-gray-100 rounded-lg shadow-sm p-8 text-center">
              <Loader className="mx-auto mb-3 text-gray-400 animate-spin" size={24} />
              <p className="text-xs text-gray-500">Loading availability...</p>
            </div>
          ) : (
            <BookingGraph
              bookings={availabilityBookings}
              vehicles={Array.isArray(vehicles) ? vehicles : []}
              initialDate={new Date().toISOString().split("T")[0]}
              onCreateBooking={(bookingData) => {
                setShowScheduler(true);
                setActiveTab("create");
                setShowAvailability(false);
                console.log("Create booking with data:", bookingData);
              }}
              onEditBooking={(booking) => {
                console.log("Edit booking:", booking);
              }}
            />
          )}
        </div>
      )}

      {/* Advanced Booking Form Modal */}
      {showAdvancedForm && (
        <div className="bg-white border border-gray-100 rounded-lg shadow-sm overflow-hidden mb-4">
          <AdvancedBookingForm
            vehicles={Array.isArray(vehicles) ? vehicles : []}
            onBookingCreated={async () => {
              setShowAdvancedForm(false);
              await fetchInitialBookingDetails();
              await loadBookings();
            }}
            onClose={() => setShowAdvancedForm(false)}
          />
        </div>
      )}

      {/* Main Content */}
      {!showAdvancedForm && (
        <>
          {/* Create Booking Tab */}
          {showScheduler && activeTab === "create" && (
            <div className="bg-white border border-gray-100 rounded-lg shadow-sm overflow-hidden">
              {vehiclesLoading ? (
                <div className="p-8 text-center">
                  <Loader className="mx-auto mb-3 text-gray-400 animate-spin" size={24} />
                  <p className="text-xs text-gray-500">Loading vehicles...</p>
                </div>
              ) : vehiclesError ? (
                <div className="p-6 text-center">
                  <div className="bg-red-50 border border-red-100 rounded-lg p-4">
                    <h3 className="text-sm font-semibold text-red-900 mb-1">Unable to Load Vehicles</h3>
                    <p className="text-xs text-red-700 mb-3">{vehiclesError}</p>
                    <button
                      onClick={() => window.location.reload()}
                      className="px-3 py-1.5 bg-red-600 text-white text-xs rounded-lg hover:bg-red-700 transition"
                    >
                      Try Again
                    </button>
                  </div>
                </div>
              ) : (
                <BookingScheduler
                  vehicles={Array.isArray(vehicles) ? vehicles : []}
                  onBookingCreated={async () => {
                    setShowScheduler(false);
                    setActiveTab("bookings");
                    await fetchInitialBookingDetails();
                    await loadBookings();
                  }}
                />
              )}
            </div>
          )}

          {/* My Bookings Tab */}
          {(!showScheduler || activeTab === "bookings") && !showAvailability && (
            <div className="bg-white border border-gray-100 rounded-lg shadow-sm overflow-hidden">
              {bookingsLoading ? (
                <div className="p-8 text-center">
                  <Loader className="mx-auto mb-3 text-gray-400 animate-spin" size={24} />
                  <p className="text-xs text-gray-500">Loading your bookings...</p>
                </div>
              ) : bookings && bookings.length > 0 ? (
                <ScheduledBookingList />
              ) : (
                <div className="p-12 text-center">
                  <div className="flex flex-col items-center gap-3">
                    <div className="p-3 bg-gray-50 rounded-full">
                      <Calendar size={32} className="text-gray-400" />
                    </div>
                    <div>
                      <h3 className="text-sm font-semibold text-gray-900 mb-1">No Bookings Yet</h3>
                      <p className="text-xs text-gray-500 mb-4">Start by creating your first scheduled vehicle booking</p>
                      <button
                        onClick={() => {
                          setShowAdvancedForm(true);
                        }}
                        className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-gray-900 text-white text-sm font-medium rounded-lg hover:bg-gray-800 transition"
                      >
                        <Plus size={14} />
                        Create Your First Booking
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
        </>
      )}
    </EmployeeLayout>
  );
}
